import { Component } from "preact"

interface ErrorBoundaryProps {
	children: preact.ComponentChildren
}

interface ErrorBoundaryState {
	error: Error | null
}

export class ErrorBoundary extends Component<
	ErrorBoundaryProps,
	ErrorBoundaryState
> {
	state: ErrorBoundaryState = { error: null }

	static getDerivedStateFromError(error: Error): ErrorBoundaryState {
		return { error }
	}

	componentDidCatch(error: Error) {
		console.error("ErrorBoundary caught:", error)
	}

	reset = () => {
		this.setState({ error: null })
	}

	render() {
		if (this.state.error) {
			return (
				<div class="d-flex justify-content-center align-items-center vh-100">
					<div class="text-center">
						<h3 class="text-danger">Something went wrong</h3>
						<p class="text-body-secondary">{this.state.error.message}</p>
						<button type="button" class="btn btn-primary" onClick={this.reset}>
							Try again
						</button>
					</div>
				</div>
			)
		}
		return this.props.children
	}
}
